import { Navbar, Footer, ScrollToTop, Breadcrumb, SchemaOrg } from '@/components/feature';
import AboutBrand from '@/pages/about/components/AboutBrand';
import AboutReputation from '@/pages/about/components/AboutReputation';
import AboutContact from '@/pages/about/components/AboutContact';

export default function AboutPage() {
  return (
    <>
      <SchemaOrg schema={{
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "关于我们 - 亚洲精品一区二区",
        "description": "亚洲精品一区二区致力于打造亚洲地区最专业的精品内容聚合与分区导览平台，通过一区精品推荐与二区优质资源两大核心板块，为用户提供高效、便捷的内容发现体验。",
        "url": "https://tsdtys3.cn/about",
      }} />
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen pt-20 pb-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
          </div>
          <header className="mb-12">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              关于我们
            </h1>
            <p className="text-foreground-600 text-sm max-w-2xl leading-relaxed">
              了解亚洲精品一区二区背后的故事、理念与团队
            </p>
          </header>
          <AboutBrand />
          <AboutReputation />
          <AboutContact />
        </div>
      </main>
      <Footer />
    </>
  );
}